
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/learn/audit-log-siem-export",
      function () {
        return require("private-next-pages/learn/audit-log-siem-export.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/learn/audit-log-siem-export"])
      });
    }
  